import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetPublicationByIdQueryResponse, GetPublicationByIdPathParams } from "../types/GetPublicationById";

export const getPublicationByIdQueryKey = (slug: GetPublicationByIdPathParams["slug"]) =>     [{url:`/api/ms-content-infoportal-backend/v1/publications/${slug}`,params:{slug:slug}}] as const;
      export function getPublicationByIdQueryOptions <TData = GetPublicationByIdQueryResponse, TError = unknown>(slug: GetPublicationByIdPathParams["slug"], options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getPublicationByIdQueryKey(slug, );

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/ms-content-infoportal-backend/v1/publications/${slug}`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/ms-content-infoportal-backend/v1/publications/:slug
 */

export function useGetPublicationById <TData = GetPublicationByIdQueryResponse, TError = unknown>(slug: GetPublicationByIdPathParams["slug"], options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getPublicationByIdQueryKey(slug, );

  const query = useQuery<TData, TError>({
    ...getPublicationByIdQueryOptions<TData, TError>(slug, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
